module.exports = __webpack_public_path__ + "static/media/Brenna P.56ed4827.png";